import styled from 'styled-components'
import * as React from 'react'
import { useMediaQuery } from '@material-ui/core'

export const OuterDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding-left: 12px;
  padding-right: 12px;
  margin-top: 15px;

  @media (min-width: 43em) {
    margin-top: 0px;
    padding: 0;
  }

  @media (min-width: 62em) {
    padding: 0;
    margin-bottom: 0;
    width: 100%;
  }
`

export const Details = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  border-radius: 15px;
  padding: 15px;
  margin-top: 15px;
  position: relative;
  z-index: 4;
  background: linear-gradient(rgb(40, 40, 40), rgb(20, 20, 20));
  border-color: #323232;
  border-width: 1px;
  border-style: solid;

  @media (min-width: 43em) {
    margin-top: 25px;
    padding: 25px;
  }
`

export const Title = styled.div`
  color: white;
  font-size: 24px;
  font-weight: 700;

  @media (min-width: 43em) {
    font-size: 46px;
  }
`

export const Description = styled.div<{
  expanded: boolean
  showExpand: boolean
  numOfLines?: number
}>`
  color: white;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  margin-bottom: ${(props) => (props.showExpand ? '10px' : '15px')};
  word-break: break-word;
  white-space: pre-wrap;
  word-wrap: normal;
  font-weight: 400;

  @media (min-width: 43em) {
    margin: 0;
    margin-bottom: ${(props) => (props.showExpand ? '15px' : '15px')};
    font-size: 18px;
  }

  ${(props) =>
    props.expanded
      ? ''
      : `display: -webkit-box;
  -webkit-line-clamp: ${props.numOfLines || 3}; /* number of lines to show */
  -webkit-box-orient: vertical;
  text-overflow: ellipsis;
  overflow: hidden;`}
`

export const LinkSpan = styled.span`
  color: white;
  white-space: pre-wrap;
  word-wrap: normal;
`

export const DescExpand = styled.div`
  color: #aaaaaa;
  font-size: 14px;
  font-weight: 600;
  margin-bottom: 15px;
  width: fit-content;
  cursor: pointer;

  @media (min-width: 43em) {
    margin-bottom: 25px;
  }
`

const LinkTag = styled.a`
  color: white;
  font-weight: bold;
  white-space: pre-wrap;
  word-wrap: normal;
`

export const DESCRIPTION_PROCESSING_CONFIG = [
  {
    regex: /(http|https):\/\/(\S+)\.([a-z]{2,}?)(.*?)( |,|$|\.)/gim,
    fn: function Parse(key: any, result: any) {
      return (
        <LinkSpan key={key}>
          <LinkTag target="_blank" href={`${result[1]}://${result[2]}.${result[3]}${result[4]}`}>
            {result[2]}.{result[3]}
            {result[4]}
          </LinkTag>
          {result[5]}
        </LinkSpan>
      )
    },
  },
  {
    regex: /(\S+)\.([a-z]{2,}?)(.*?)( |,|$|\.)/gim,
    fn: function Parse(key: any, result: any) {
      return (
        <LinkSpan key={key}>
          <LinkTag target="_blank" href={`http://${result[1]}.${result[2]}${result[3]}`}>
            {result[1]}.{result[2]}
            {result[3]}
          </LinkTag>
          {result[4]}
        </LinkSpan>
      )
    },
  },
]

export function useShowExpand(isDivLoaded: boolean, numOfLines?: number): boolean {
  const isMobile = useMediaQuery('(max-width: 43em)')
  const [showExpand, setShowExpand] = React.useState(false)

  React.useEffect(() => {
    const el = document.getElementById('desc')
    if (isDivLoaded && el) {
      const divHeight = el.offsetHeight
      const lineHeight = 1.5 * (isMobile ? 14 : 16)
      const lines = divHeight / lineHeight
      setShowExpand(lines > (numOfLines ? numOfLines - 0.5 : 2.5))
    }
  }, [isDivLoaded, isMobile])
  return showExpand
}
